import {TweenMax} from 'gsap';



function init() {
    if (this._initiated) return;

    this.el.style.pointerEvents = 'none';

    const CoverNextButton = require('./ui/CoverNextButton');
    this.nextUI = CoverNextButton(this.el.querySelector('.cover__next-button a'));

    this._initiated = true;

    return this;
}

function show() {
    if (!this._initiated) return;
    this.el.classList.remove('deactivate');
    this.el.classList.add('active');
    this.nextUI.show();

    return this;
}

function hide(destroy) {
    if (!this._initiated) return;
    this.el.classList.remove('active');
    this.el.classList.add('deactivate');
    this.nextUI.hide();

    if (destroy) {
        TweenMax.delayedCall(1.2 + 0.45, this.destroy, [], this);
    }

    return this;
}

function enable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'all';
    return this;
}

function disable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'none';
    return this;
}

function destroy() {
    if (!this._initiated) return;

    this.el.classList.remove('active');
    this.el.classList.remove('deactivate');
    // this.ttlAnim.destroy();
    this.nextUI.destroy();

    this.ttlAnim = null;
    this.nextUI = null;
    this._initiated = false;

    if (this.el.parentNode) this.el.parentNode.removeChild(this.el);

    return this;
}

module.exports = el => {
    const Controller = {
        el: el
    };

    Controller.init = init.bind(Controller);
    Controller.enable = enable.bind(Controller);
    Controller.disable = disable.bind(Controller);
    Controller.show = show.bind(Controller);
    Controller.hide = hide.bind(Controller);
    Controller.destroy = destroy.bind(Controller);

    return Controller;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/VideoCoverSectionController.js